//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Debounce from '@/libs/debounce';
import { productBatchAuditApi, productBatchVirtualSalesApi } from '@/api/product';
export default {
  name: 'batchAudit',
  props: {
    idList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      formData: {
        reason: '',
        auditStatus: 'success',
        idList: []
      },
      dialogVisible: false,
      rules: {
        auditStatus: [{
          required: true,
          message: '请选择审核状态',
          trigger: 'change'
        }],
        reason: [{
          required: true,
          message: '请填写拒绝原因',
          trigger: 'blur'
        }]
      },
      isAppend: true
    };
  },
  methods: {
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.formData = {
        reason: '',
        auditStatus: 'success',
        idList: []
      };
    },
    /** 提交按钮 */
    submitForm: Debounce(function (formData) {
      var _this = this;
      this.$refs[formData].validate(function (valid) {
        if (valid) {
          _this.formData.idList = _this.idList;
          productBatchAuditApi(_this.formData).then(function (response) {
            _this.$modal.msgSuccess('操作成功');
            _this.handleClose();
            _this.$emit('subBatchAuditSuccess');
          });
        }
      });
    })
  }
};